import { extraColors } from "../../utils/theme"

export enum WastewaterCategory {
  NOT_CALCULATED = "Not Calculated",
  NOT_DETECTED = "Not Detected",
  NO_DATA = "Missing Data",
  LOW = "Low",
  MEDIUM = "Medium",
  HIGH = "High",
}

export const WASTEWATER_CHART_COLORS = {
  [WastewaterCategory.NOT_DETECTED]: {
    deep: extraColors.status.greenDeep,
    muted: extraColors.status.greenMuted,
    main: extraColors.status.greenDark,
    light: extraColors.status.greenLight,
  },
  [WastewaterCategory.NOT_CALCULATED]: {
    deep: extraColors.transparent,
    muted: extraColors.dark20,
    main: extraColors.transparent,
    light: extraColors.dark20,
  },
  [WastewaterCategory.NO_DATA]: {
    deep: extraColors.transparent,
    muted: extraColors.dark20,
    main: extraColors.transparent,
    light: extraColors.dark20,
  },
  [WastewaterCategory.LOW]: {
    deep: extraColors.status.greenDeep,
    muted: extraColors.status.greenMuted,
    main: extraColors.status.greenDark,
    light: extraColors.status.greenLight,
  },
  [WastewaterCategory.MEDIUM]: {
    deep: extraColors.status.yellowDeep,
    muted: extraColors.status.yellowMuted,
    main: extraColors.status.yellowDark,
    light: extraColors.status.yellowLight,
  },
  [WastewaterCategory.HIGH]: {
    deep: extraColors.status.redDeep,
    muted: extraColors.status.redMuted,
    main: extraColors.status.redDark,
    light: extraColors.status.redLight,
  },
  text: extraColors.medium,
} as const

export const WASTEWATER_HEATMAP_CELL_COLORS = {
  ...WASTEWATER_CHART_COLORS,
  [WastewaterCategory.HIGH]: {
    deep: extraColors.status.redDeep,
    muted: extraColors.status.redMuted,
    main: extraColors.status.redLight,
    light: extraColors.status.redGhost,
  },
}

export const CELL_WIDTH = 23
export const CELL_HEIGHT = 15
export const CELL_GAP = 6
export const ROW_HEIGHT = CELL_HEIGHT + CELL_GAP
export const ICON_SIZE = 8
export const Y_AXIS_WIDTH = 200
export const Y_AXIS_LABEL_OFFSET = 24
export const X_AXIS_HEIGHT = 50 // magic value that seems to work well

// Heatmap data point details
export interface HeatmapDataPointDetails {
  sampleEndDate: string
  sampleSite: string
  copies: string
  isAnomaly: boolean
  isSelected: boolean
  value: WastewaterCategory
}
